import { createApp } from "vue";
import App from "./App.vue";
import router from "./plugins/router";

// スタイル
import vuetify from "./plugins/vuetify";
import '@mdi/font/css/materialdesignicons.css'
import "./assets/main.css";

// AWS Cognito導入 -パートA
import { UserManager } from "oidc-client-ts";

// FireBase導入-パートB
// firebase
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";

// FireBase導入-パートC
// ■初期化
var firebaseConfig = {
  apiKey: "AIzaSyARcrDiw5dvJ1ma8mSwXvqp-5nL4qjVNbw",
  authDomain: "firesample-fa717.firebaseapp.com",
  databaseURL: "https://firesample-fa717-default-rtdb.firebaseio.com",
  projectId: "firesample-fa717",
  storageBucket: "firesample-fa717.appspot.com",
  messagingSenderId: "513126628902",
  appId: "1:513126628902:web:9b21c998188bb2874ef0e7",
  measurementId: "G-PYRZLM3SN4"
};
firebase.initializeApp(firebaseConfig);
window.firebase = firebase;

// ////////////////////
// AWS Cognito : ログイン(login)
// id: ftymdk@yahoo.co.jp, pw: qZYqnqAD68cRV89!
// TODO: 本番では本番用を使用すること
// ////////////////////
// * サインイン用設定
const cognitoAuthConfig = {
    authority: "https://cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_qvhEuav03",
    client_id: "6vjtpsu99ajaej3gpq900ksh6i",
    redirect_uri: "https://www.nariji.net/", // 本番用
    // redirect_uri: "http://localhost:8080/", // ローカル開発用
    response_type: "code",
    scope: "phone openid email"
};
export const userManager = new UserManager({
    ...cognitoAuthConfig,
});

// * サインアウト用関数
export async function signOutRedirect () {
    const clientId = "6vjtpsu99ajaej3gpq900ksh6i";
    const logoutUri = "https://www.nariji.net/"; // 本番用
    // const logoutUri = "http://localhost:8080/"; // ローカル開発用
    const cognitoDomain = "https://ap-northeast-1qvheuav03.auth.ap-northeast-1.amazoncognito.com";
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}

// ////////////////////
// app
// ////////////////////
// Vueアプリケーションの作成とマウント
const app = createApp(App)
app.use(router).use(vuetify)
app.mount("#app")


